import { adminLogin } from '@/api/adminuser'
import { getCookie, setCookie, removeCookie } from '@/utils/auth'
import { timestampToTime3 } from '@/utils/timestamp'

const adminuser = {
  state: {
    admintoken: getCookie('admintoken'),
    adminname: getCookie('adminname') // 登录名
  },

  mutations: {
    SET_ADMIN_TOKEN: (state, admintoken) => {
      state.admintoken = admintoken
    },
    SET_ADMIN_NAME: (state, adminname) => {
      state.adminname = adminname
    }
  },

  actions: {
    // 用户密码登录
    adminLogin ({ commit }, data) {
      return new Promise((resolve, reject) => {
        adminLogin(data.username, data.password).then(response => {
          setCookie('admintoken', response.access_token, 2)
          setCookie('adminname', data.username, 2)
          setCookie('adminuserid', response.userid, 2)
          setCookie('admintokentime', timestampToTime3(new Date()))
          commit('SET_ADMIN_TOKEN', response.access_token)
          commit('SET_ADMIN_NAME', data.username)
          resolve(response.access_token)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 前端 登出
    adminFedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_ADMIN_TOKEN', '')
        commit('SET_ADMIN_NAME', '')
        removeCookie('admintoken')
        removeCookie('adminname')
        removeCookie('admintokentime')
        removeCookie('adminuserid')
        resolve()
      })
    }
  }
}

export default adminuser



// WEBPACK FOOTER //
// ./src/store/modules/adminuser.js